import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import { ShopRegionMatchGQL } from './gql/shop-region.gql.generated';
import { IShopGeoRegionDetail, IShopRegionMatchVariables } from './types/shop-region';

@Injectable()
export class ShopRegionService {
  constructor(private shopRegionMatchGQL: ShopRegionMatchGQL) {}

  regionFromAddressInput(
    input: IShopRegionMatchVariables,
  ): Observable<IShopGeoRegionDetail | undefined | null> {
    return this.shopRegionMatchGQL.fetch(input).pipe(mapFetchResultData((r) => r.shopRegionMatch));
  }
}
